import { render, staticRenderFns } from "./singleRoleDetails.vue?vue&type=template&id=3b772be2&scoped=true&"
import script from "./singleRoleDetails.vue?vue&type=script&lang=js&"
export * from "./singleRoleDetails.vue?vue&type=script&lang=js&"
import style0 from "./singleRoleDetails.vue?vue&type=style&index=0&id=3b772be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b772be2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kolobox-admin/kolobox-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VCardTitle,VCheckbox,VFlex,VLayout,VSpacer,VToolbar,VToolbarTitle})
